export default {
    Metadata: {
        Name: "Lower",
        Description: "Returns the specified string in all lower case.",
        Syntax: "Lower(string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(stringInput) {
        if (stringInput == undefined || stringInput == null) {
            return "";
        }

        if (typeof stringInput == "string") {
            return stringInput.toLowerCase();
        }
        else {
            return stringInput.toString().toLowerCase();
        }
    },
};

